import { InvalidCatalogDefinitionError } from "../errors.model";
import type { EnablementCondition, PatientFact, QuestionnaireFactCondition } from "../questionnaire-definition.model";
import { DEFAULT_TIMEZONE } from "./clinic-timezone";

export interface PatientFactSource {
  birthDate: string;
  assignedAt: string;
}

const clinicDate = new Intl.DateTimeFormat("en-CA", {
  timeZone: DEFAULT_TIMEZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/** Whole years on a calendar date or instant, using the clinic's date for instants. */
export function ageOn(birthDate: string, on: string): number {
  const date = /^\d{4}-\d{2}-\d{2}$/.test(on) ? on : clinicDate.format(new Date(on));
  const years = Number(date.slice(0, 4)) - Number(birthDate.slice(0, 4));
  // Feb 29 birthdays reach their next year on March 1 in non-leap years.
  return years - (date.slice(5) < birthDate.slice(5) ? 1 : 0);
}

export function factValue(fact: PatientFact, source: PatientFactSource): number {
  switch (fact) {
    case "age":
      return ageOn(source.birthDate, source.assignedAt);
  }
}

export function isFactCondition(c: EnablementCondition): c is QuestionnaireFactCondition {
  return "fact" in c;
}

/** Validate authored and restored facts at the domain boundary. */
export function assertFactCondition(condition: QuestionnaireFactCondition): void {
  if (
    condition.fact !== "age" ||
    !["=", "!=", ">", "<", ">=", "<="].includes(condition.operator) ||
    !Number.isInteger(condition.value) ||
    condition.value < 0
  ) {
    throw new InvalidCatalogDefinitionError("Patient age conditions require a comparison against a whole number >= 0");
  }
}
